import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30" role="contentinfo">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-accent-500 text-xl"></i>
              </div>
              <span className="text-base font-bold text-foreground-100 font-heading">
                夫妻影院
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              夫妻影院是国内领先的免费电视剧在线观看平台，提供海量高清影视资源，每日更新最新剧集，追剧时光，有你有我。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(1, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                首页推荐
              </Link>
              <Link
                to="/category/guochan"
                className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                国产剧大全
              </Link>
              <Link
                to="/category/hanju"
                className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                韩剧热播
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-500">
              <span>邮箱：contact@fuqicinema.com</span>
              <span>服务时间：7×24小时</span>
              <span>内容更新：每日更新</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 夫妻影院 - 追剧时光，有你有我。本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">
              免责声明
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer" rel="nofollow">
              版权投诉
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}